import { accionesHechas, accionesPendientes, avisoDeTransicion, progresoRecorrido } from './recorrido';

export const EVENTO_ELEGIR_ACCION = 'sorby-ia:elegir-accion';
export const EVENTO_ESTADO = 'sorby-ia:estado';

export const pasosVisibles = (pasos, esDueno) => (pasos || []).filter((p) => esDueno === true || !p.soloDueno);

// Quien no es dueño no ve los pasos que solo el dueño puede hacer; el chat y la card parten de este mismo recorte.
export const onboardingParaRol = (onboarding, esDueno) =>
  onboarding ? { ...onboarding, pasos: pasosVisibles(onboarding.pasos, esDueno) } : onboarding;

// El «Listo ✓» se calcula sobre lo que la persona ve: un paso solo de dueño no la felicita ni le ofrece botones que no tiene.
export const avisoDeTransicionParaRol = (previo, actual, esDueno) =>
  avisoDeTransicion(onboardingParaRol(previo, esDueno), onboardingParaRol(actual, esDueno));

export const resumenPrimerosPasos = (onboarding, esDueno) => {
  const delRol = onboardingParaRol(onboarding, esDueno);
  const pendientes = accionesPendientes(delRol);
  const progreso = progresoRecorrido(delRol);
  return {
    visible: onboarding?.activo === true && pendientes.length > 0,
    progreso: progreso && { ...progreso, fraccion: progreso.hechos / progreso.total },
    hechos: accionesHechas(delRol),
    pendientes,
  };
};

export const pedirAccion = (paso) => {
  if (typeof window !== 'undefined') {
    window.dispatchEvent(new CustomEvent(EVENTO_ELEGIR_ACCION, { detail: { clave: paso.clave, titulo: paso.titulo } }));
  }
};

export const avisarEstado = (miObra) => {
  if (typeof window !== 'undefined') window.dispatchEvent(new CustomEvent(EVENTO_ESTADO, { detail: miObra }));
};
